export const grey = {
  900: '#22282B',
  800: '#384248',
  700: '#5A676D',
  600: '#65747B',
  500: '#6F7E86',
  400: '#7F8F94',
  300: '#A8B3B8',
  200: '#C4CBCF',
  100: '#EBEDEE',
  50: '#FAFAFA',
}
